import type { Match } from '@uefadigital/panenka';
import { PkCarousel, PkEmptyMessage } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';

import { LineUpsField } from 'components/LineUpsField';
import useIsDesktop from 'hooks/useIsDesktop';
import type { ConfigCompetition } from 'utils/config';

import * as style from './style.module.css';

export interface ILineUpsCarousel {
  matchData: Array<Match>;
  teamName: string;
  fieldSize: {
    desktop: number;
    mobile: number;
    desktopJerseySize: number;
    mobileJerseySize: number;
  };
  isPDFPrint?: boolean;
  competition?: ConfigCompetition;
}

export const LineUpsCarousel = ({
  matchData,
  teamName,
  fieldSize,
  isPDFPrint = false,
  competition,
}: ILineUpsCarousel) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const teamTitle = (
    <div
      slot="headline"
      className={`${
        isDesktop ? 'pk-font-size--xl' : 'pk-font-size--l'
      } pr-mb--6  pr-font-weight--500 pr-font-size--14 pk-line-height--sm pk-text--ui-06 `}
    >
      {teamName}
    </div>
  );

  if (matchData.length === 0) {
    return (
      <div>
        {teamTitle}
        <PkEmptyMessage class="pk-m--xl">{t('previous_lineups_are_not_available_for_this_team')}</PkEmptyMessage>
      </div>
    );
  }

  if (isPDFPrint) {
    return (
      <div className={`${style.carouselMarginBottom} pr-display--flex pk-d--none pr-flex-direction--column`}>
        {teamTitle}
        <div>
          {matchData.map((match, i) => (
            <div className="pr-my--0 pr-p--4" key={i}>
              <LineUpsField
                match={match}
                competition={competition}
                previousMatch
                fieldSize={fieldSize}
                isDesktop={isDesktop}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <PkCarousel
        className={isDesktop ? `${style.carouselMarginBottom}` : ''}
        breakpoints='{
      "0":{"slidesPerView":"1.1","slidesPerGroup":1,"spaceBetween":16},
      "531":{"slidesPerView":"1.5","slidesPerGroup":1,"spaceBetween":16},
      "699":{"slidesPerView":"2.2","slidesPerGroup":1,"spaceBetween":16},
      "799":{"slidesPerView":"2.2","slidesPerGroup":1,"spaceBetween":16},
      "959":{"slidesPerView":"2.5","slidesPerGroup":1,"spaceBetween":16},
      "1100":{"slidesPerView":"2.5","slidesPerGroup":1,"spaceBetween":32},
      "1250":{"slidesPerView":"2.8","slidesPerGroup":1,"spaceBetween":32},
      "1439":{"slidesPerView":"3.3","slidesPerGroup":1,"spaceBetween":32}
    }'
      >
        {teamTitle}
        {matchData.map((match, i) => (
          <div key={i}>
            <LineUpsField
              match={match}
              competition={competition}
              previousMatch
              key={i}
              fieldSize={fieldSize}
              isDesktop={isDesktop}
            />
          </div>
        ))}
      </PkCarousel>
    </div>
  );
};
